import { render, staticRenderFns } from "./ManagementRequestsView.vue?vue&type=template&id=58484298&scoped=true"
import script from "./ManagementRequestsView.vue?vue&type=script&lang=js"
export * from "./ManagementRequestsView.vue?vue&type=script&lang=js"
import style0 from "./ManagementRequestsView.vue?vue&type=style&index=0&id=58484298&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58484298",
  null
  
)

export default component.exports